import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import {
	NavigationWrapper,
	PickerHOC,
	TargetTypesWrapper,
	TargetsAllianzUtilsWrapper,
	TargetsWrapper,
	UiWrapper,
} from '@coinscrap/webapp-core';

import Header from 'layout/components/Header/Header';

import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { MainModal } from 'components/MainModal/MainModal';

import { useGetError } from 'hooks/useGetError';
import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import { AgentContext } from '../../contexts/agent';
import { useCoinscrapPageView } from '../../hooks/useCoinscrapPageView';

export const UpsertProduct = PickerHOC(
	{
		targetType: {
			arrayItemMatcher: {
				itemPropertyPath: 'identifier',
				type: 'value',
				value: 'ALLIANZ_VIDA_RIESGO',
			},
			sourcePath: 'targetTypes',
			sourceWrapper: TargetTypesWrapper,
		},
		targets: {
			sourcePath: 'targets',
			sourceWrapper: TargetsWrapper,
		},
	},
	LoadingScreen,
)(() => {
	const { agent } = useContext(AgentContext);

	const { navigateTo } = NavigationWrapper.use();
	const { useHeader, useLoading, openModal } = UiWrapper.use();
	const { instanciateNewTarget, getTargetPolicy } = TargetsAllianzUtilsWrapper.use();
	const { targets, targetType } = PickerHOC.use();

	const [loading, setLoading] = useState();

	useLoading(loading, { loadingMessage: loading });
	useHeader(<Header />, []);
	useInitialScrollToTop();
	useCoinscrapPageView('UpsertProduct');
	const getError = useGetError();

	const targetId = useMemo(() => targets?.[0]?.id, [targets]);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const needsToCreateNewTarget = useMemo(() => (targets?.[0]?.id ? false : true), []);
	const [targetCreationFinished, setTargetCreationFinished] = useState(false);

	useEffect(() => {
		if (
			(targetId && !needsToCreateNewTarget) ||
			(targetId && needsToCreateNewTarget && targetCreationFinished)
		) {
			(async () => {
				try {
					console.log('📌 USER HAS TARGET', targetId);
					setLoading('Accediendo...');
					CONFIG.routing.upsertProduct.next(navigateTo, targetId);
				} catch (e) {
					setLoading(undefined);
					openModal(() => <MainModal type="error" text={getError(e)} />, {
						disableClickAway: true,
						closeButton: true,
						modalClass: isMobile ? 'modal-xl' : 'modal-main',
						key: 'modal-UpsertProductRedirect-KO',
					});
				}
			})();
		} else if (!targetId || targetCreationFinished) {
			(async () => {
				try {
					console.log('📌 CREATE NEW TARGET FOR USER');
					setLoading('Creando...');

					console.log('🔎 agent', agent);

					const createdTarget = await instanciateNewTarget({
						targetType: targetType.id,
						productIdentifier: targetType.metadata.productSupported,
						agentPA: agent.PA,
						agentCode: agent.AGENT_CODE,
					});
					console.info('💢 createdTarget', createdTarget);

					const createdPolicy = await getTargetPolicy(createdTarget.id);
					console.info('💢 createdPolicy', createdPolicy);

					setTargetCreationFinished(true);
				} catch (e) {
					setLoading(undefined);
					openModal(() => <MainModal type="error" text={getError(e)} />, {
						disableClickAway: true,
						closeButton: true,
						modalClass: isMobile ? 'modal-xl' : 'modal-main',
						key: 'modal-UpsertProduct-KO',
					});
				}
			})();
		}
		// eslint-disable-next-line
	}, [targetId, targetCreationFinished]);

	return <></>;
});
